import { ENABLE_CHAT as SOCKET_ENABLE_CHAT} from '../../events/DashboardToServer'
import { DISABLE_CHAT as SOCKET_DISABLE_CHAT, SET_NUMBER_OF_CHATTERS as SOCKET_SET_NUMBER_OF_CHATTERS} from '../../events/DashboardToServer'
import {GET_NUMBER_OF_CHATTERS as SOCKET_GET_NUMBER_OF_CHATTERS} from '../../events/ClientToServer'

export const CHAT_DISABLED = 'CHAT_DISABLED'
export const CHAT_ENABLED = 'CHAT_ENABLED'
export const ENABLE_CHAT = 'ENABLE_CHAT'
export const DISABLE_CHAT = 'DISABLE_CHAT'
export const SET_NUMBER_OF_CHATTERS = 'SET_NUMBER_OF_CHATTERS'
export const GET_NUMBER_OF_CHATTERS = 'GET_NUMBER_OF_CHATTERS'
export const NUMBER_OF_CHATTERS_SETTED = 'NUMBER_OF_CHATTERS_SETTED'
export const NUMBER_OF_CHATTERS_SENT = 'NUMBER_OF_CHATTERS_SENT'


export const chat = (state = [], action) => {
    switch (action.type) {
        case CHAT_ENABLED:
            var ss = {
                ...state,
            }
            ss.enabled = true
            return ss   
    
        case CHAT_DISABLED:
            var ss = {
                ...state,
            }
            ss.enabled = false
            return ss   
        
        case NUMBER_OF_CHATTERS_SETTED:
            var ss = {
                ...state,
            }
            ss.numberOfChatters = action.numberOfChatters
            return ss   
        
        case NUMBER_OF_CHATTERS_SENT:
                var ss = {
                    ...state,
                }
                ss.numberOfChatters = action.numberOfChatters
                return ss   
    
        default:
            return state
    }
}

export const enableChat = (socket) => {
    socket.emit(SOCKET_ENABLE_CHAT)
    return { type: ENABLE_CHAT}
}

export const disableChat = (socket) => {
    socket.emit(SOCKET_DISABLE_CHAT)
    return { type: DISABLE_CHAT}
}

export const chatEnabled = () => {
    return { type: CHAT_ENABLED}
}

export const setNumberOfChatters = (socket,numberOfChatters) =>{
    socket.emit(SOCKET_SET_NUMBER_OF_CHATTERS, {numberOfChatters})
    return {type:SET_NUMBER_OF_CHATTERS}
}

export const getNumberOfChatters = (socket) =>{
    socket.emit(SOCKET_GET_NUMBER_OF_CHATTERS)
    return {type:GET_NUMBER_OF_CHATTERS}
}


export const numberOfChattersSetted =(numberOfChatters) =>{
    return {type:NUMBER_OF_CHATTERS_SETTED, numberOfChatters:numberOfChatters}
}

export const numberOfChattersSent =(numberOfChatters) =>{
    return {type:NUMBER_OF_CHATTERS_SENT, numberOfChatters:numberOfChatters}
}

export const chatDisabled = () => {
    return { type: CHAT_DISABLED}
}


// WEBPACK FOOTER //
// ./src/reducers/chat/index.js